var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:('max-width:'+_vm.width),attrs:{"id":'olivertooltip-' + this.myid,"tabindex":"0","data-toggle":"tooltip","title":_vm.text}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }